exports = module.exports = {}

exports.DEV_DEFAULT_HOST = 'https://admin18.fat.klook.io/'
exports.DEV_PRO_HOST = 'https://t18.fat.klook.io'
exports.DEV_AUTH_HOST = 'https://admin-auth.klook.io'
